/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Asset_Library_And_VaultsInputs */

const en_asset_library_and_vaults = /** @type {(inputs: Asset_Library_And_VaultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset Library & Vaults`)
};

const es_asset_library_and_vaults = /** @type {(inputs: Asset_Library_And_VaultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biblioteca de activos y Bóvedas`)
};

const fr_asset_library_and_vaults = /** @type {(inputs: Asset_Library_And_VaultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bibliothèque de biens & Coffres-forts`)
};

const de_asset_library_and_vaults = /** @type {(inputs: Asset_Library_And_VaultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset-Bibliothek & Vaults`)
};

const ja_asset_library_and_vaults = /** @type {(inputs: Asset_Library_And_VaultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アセットライブラリ＆保管庫`)
};

const zh_asset_library_and_vaults = /** @type {(inputs: Asset_Library_And_VaultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`资产库与金库`)
};

const ar_asset_library_and_vaults = /** @type {(inputs: Asset_Library_And_VaultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مكتبة الأصول والخزائن`)
};

const id_asset_library_and_vaults = /** @type {(inputs: Asset_Library_And_VaultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pustaka Aset & Vault`)
};

const it_asset_library_and_vaults = /** @type {(inputs: Asset_Library_And_VaultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Libreria Risorse & Vaults`)
};

const ru_asset_library_and_vaults = /** @type {(inputs: Asset_Library_And_VaultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Библиотека активов и хранилища`)
};

const pt_asset_library_and_vaults = /** @type {(inputs: Asset_Library_And_VaultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biblioteca de Ativos e Cofres`)
};

const ko_asset_library_and_vaults = /** @type {(inputs: Asset_Library_And_VaultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`에셋 라이브러리 및 보관소`)
};

/**
* | output |
* | --- |
* | "Asset Library & Vaults" |
*
* @param {Asset_Library_And_VaultsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const asset_library_and_vaults = /** @type {((inputs?: Asset_Library_And_VaultsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Asset_Library_And_VaultsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_asset_library_and_vaults(inputs)
	if (locale === "es") return es_asset_library_and_vaults(inputs)
	if (locale === "fr") return fr_asset_library_and_vaults(inputs)
	if (locale === "de") return de_asset_library_and_vaults(inputs)
	if (locale === "ja") return ja_asset_library_and_vaults(inputs)
	if (locale === "zh") return zh_asset_library_and_vaults(inputs)
	if (locale === "ar") return ar_asset_library_and_vaults(inputs)
	if (locale === "id") return id_asset_library_and_vaults(inputs)
	if (locale === "it") return it_asset_library_and_vaults(inputs)
	if (locale === "ru") return ru_asset_library_and_vaults(inputs)
	if (locale === "pt") return pt_asset_library_and_vaults(inputs)
	return ko_asset_library_and_vaults(inputs)
});